var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.compact)?_c('div',[_vm._t("default")],2):_c('BaseModal',{attrs:{"is-open":_vm.open,"close":() => _vm.$emit('close')}},[_c('div',{staticClass:"bg-white dark:bg-grey-900 rounded-t-xl w-screen px-4 pt-14 pb-6"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }